export default __webpack_public_path__ + "images/Sapphire_f11906b.png";